import React, { useContext, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import AuthContext from "../context/Authcontext";

import cartShopping from "../assets/cart-shopping.svg";
import stat from "../assets/stats.svg";
import bell from "../assets/bell.svg";
import time from "../assets/time.svg";
import video from "../assets/video.svg";
import menu from "../assets/idk.svg";
import cloud from "../assets/cloud.svg";
import earth from "../assets/earth.svg";
import certificate from "../assets/certificate.svg";

import file from "../assets/file.png";
import videoimg from "../assets/video.png";
import text from "../assets/text.png";

const Presentationformation = () => {
  const navigate = useNavigate();

  const { id } = useParams();
  const { contextData } = useContext(AuthContext);

  const [formation, setformation] = useState("");

  const [nember, setnember] = useState(1);

  const [unite, setunite] = useState([]);
  const [filerousource, setfilerousource] = useState([]);
  const [videorousource, setvideorousource] = useState([]);
  const [textrousource, settextrousource] = useState([]);
  const [curuculum, setcuruculum] = useState({});
  const [curuculumredy, setcuruculumredy] = useState([]);
  const [ref, setref] = useState(true);

  const getunites = async () => {
    const { data } = await axios.get(
      `https://pfebackend-zbz0.onrender.com/api/unites/${id}/`
    );
    setunite(data);

    data[0] && setnember(data[0].id);
  };

  const getcuruculum = async () => {
    const { data } = await axios.get(
      `https://pfebackend-zbz0.onrender.com/api/curuculum/${id}/`
    );

    setcuruculum(data);
  };

  const displaycuruculum = () => {
    const list = [];

    for (const key in curuculum) {
      if (Object.hasOwnProperty.call(curuculum, key)) {
        const element = curuculum[key];

        list.push({ [key]: element });
      }
    }
    setcuruculumredy(list);

    setref(!ref);
  };

  const getformation = async () => {
    const { data } = await axios.get(
      `https://pfebackend-zbz0.onrender.com/api/formation/${id}/`
    );
    setformation(data);
  };

  //this gets the images for the formations
  const getFiles = async (ids) => {
    const response = await axios.get(
      `https://pfebackend-zbz0.onrender.com/api/formations/image/${id}/`,
      {
        responseType: "blob",
      }
    );
    // return response.data;
    const blob = new Blob([response.data]);
    let url = window.URL.createObjectURL(blob);
    const image = document.getElementById(`image`);
    image.src = url;
  };

  const getFileRousourses = async () => {
    const { data } = await axios.get(
      `https://pfebackend-zbz0.onrender.com/api/filerousources/${id}/${nember}/`
    );
    return data;
  };
  const getVideoRousourses = async () => {
    const { data } = await axios.get(
      `https://pfebackend-zbz0.onrender.com/api/videorousources/${id}/${nember}/`
    );
    return data;
  };
  const getTextRousourses = async () => {
    const { data } = await axios.get(
      `https://pfebackend-zbz0.onrender.com/api/textrousources/${id}/${nember}/`
    );
    return data;
  };

  const changeunite = (e) => {
    setnember(e.id);
  };

  const getfile = async (e) => {
    axios({
      url: `https://pfebackend-zbz0.onrender.com/api/file/${e.id}/`,
      method: "GET",
      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", e.file.split("/").pop()); // set the filename and extension
      document.body.appendChild(link);
      link.click();
    });
  };
  function sortByOrder(...arrays) {
    const combinedPeople = arrays.flat();
    return combinedPeople.sort((a, b) => a.order - b.order);
  }
  const handelEnroll = async () => {
    // console.log(contextData.user);

    if (!contextData.user) {
      navigate("/login");
      return;
    } else {
      if (contextData.user.active) {
        const { data } = await axios.post(
          `https://pfebackend-zbz0.onrender.com/api/formations/enrole/${id}/`,
          null,
          {
            headers: {
              Authorization: `Bearer ${contextData.authTokens.access}`,
            },
          }
        );
        navigate(`/formation/${id}/`);
      } else {
        console.log(contextData.user.active);
        navigate(`/verifyemail`);
      }
    }
  };

  const getmarginzero = () => {
    const element = document.getElementById("navnav");
    element.classList.add("marginzero");
  };

  function TextComponent(text) {
    if (text) {
      const paragraphs = text.split("\n");

      const renderedParagraphs = paragraphs.map((paragraph, index) => (
        <p className="overview-text" key={index}>
          {paragraph}
        </p>
      ));

      return <>{renderedParagraphs}</>;
    }
  }

  const gotovideo = (url) => {
    navigate(url);
  };

  useEffect(() => {
    displaycuruculum();
  }, [curuculum]);

  useEffect(() => {
    getcuruculum();
    getmarginzero();
    getformation();
    getunites();
  }, []);
  useEffect(() => {
    getFileRousourses();
    getVideoRousourses();
    getTextRousourses();
  }, [nember]);

  return (
    <div className="training-presentation-container">
      <div className="presentation-container-header">
        <h1 className="presentation-container-title">{formation.name}</h1>
        <p className="presentation-container-description">
          {formation.description}
        </p>

        <button className="enrollbutton" onClick={handelEnroll}>
          <span className="cartShopping-container">
            <img className="cartShopping" src={cartShopping} alt="" />
          </span>
          Enroll Now!
        </button>
      </div>

      <div className="presentation-container-section-one">
        <div className="presentation-container-section-one-left">
          <h3 className="presentation-training-name">{formation.name}</h3>
          {TextComponent(formation.overview)}
          <button className="enrollbutton" onClick={handelEnroll}>
            <span className="cartShopping-container">
              <img className="cartShopping" src={cartShopping} alt="" />
            </span>
            Enroll Now!
          </button>
        </div>

        <div className="presentation-container-section-one-right">
          <div className="fancybar"></div>

          <ul className="presentation-container-list">
            <li className="presentation-container-list-item">
              <div className="presentation-container-list-item-image-container">
                <img
                  className="presentation-container-list-item-image"
                  src={stat}
                  alt=""
                />
              </div>

              <p className="presentation-container-list-item-text">
                LIFETIME ACCESS
              </p>
            </li>
            <li className="presentation-container-list-item">
              <div className="presentation-container-list-item-image-container">
                <img
                  className="presentation-container-list-item-image"
                  src={bell}
                  alt=""
                />
              </div>

              <p className="presentation-container-list-item-text">
                BEGINNER TO PRO
              </p>
            </li>
            <li className="presentation-container-list-item">
              <div className="presentation-container-list-item-image-container">
                <img
                  className="presentation-container-list-item-image"
                  src={time}
                  alt=""
                />
              </div>

              <p className="presentation-container-list-item-text">
                {" "}
                14 HOURS OF VIDEO
              </p>
            </li>
            <li className="presentation-container-list-item">
              <div className="presentation-container-list-item-image-container">
                <img
                  className="presentation-container-list-item-image"
                  src={video}
                  alt=""
                />
              </div>

              <p className="presentation-container-list-item-text">
                {" "}
                180 LESSONS
              </p>
            </li>
            <li className="presentation-container-list-item">
              <div className="presentation-container-list-item-image-container">
                <img
                  className="presentation-container-list-item-image"
                  src={menu}
                  alt=""
                />
              </div>

              <p className="presentation-container-list-item-text">
                {" "}
                CHEAT SHEETS
              </p>
            </li>
            <li className="presentation-container-list-item">
              <div className="presentation-container-list-item-image-container">
                <img
                  className="presentation-container-list-item-image"
                  src={cloud}
                  alt=""
                />
              </div>

              <p className="presentation-container-list-item-text">
                {" "}
                DOWNLOADABLE
              </p>
            </li>
            <li className="presentation-container-list-item">
              <div className="presentation-container-list-item-image-container">
                <img
                  className="presentation-container-list-item-image"
                  src={earth}
                  alt=""
                />
              </div>

              <p className="presentation-container-list-item-text">SUBTITLES</p>
            </li>
            <li className="presentation-container-list-item">
              <div className="presentation-container-list-item-image-container">
                <img
                  className="presentation-container-list-item-image"
                  src={certificate}
                  alt=""
                />
              </div>

              <p className="presentation-container-list-item-text">
                CERTIFICATE
              </p>
            </li>
          </ul>
        </div>
      </div>

      <div className="Curriculum-container">
        <h2 className="Curriculum-container-title">Course Curriculum</h2>

        {curuculumredy.length > 0 &&
          curuculumredy.map((e) => {
            for (const key in e) {
              if (Object.hasOwnProperty.call(e, key)) {
                const element = e[key];
                return (
                  <div key={key}>
                    <p className="unite-title">{key}</p>
                    {sortByOrder(
                      element["fileroussource"],
                      element["videoroussource"],
                      element["textroussource"]
                    ).map((e, index) => {
                      if (e.free) {
                        return (
                          <div key={index}>
                            {e.type === "file" ? (
                              <div
                                onClick={() => getfile(e)}
                                className="curriculum-element"
                              >
                                <div className="complited-container complited-container-hover">
                                  <img
                                    className="complited-image"
                                    src={file}
                                    alt=""
                                  />
                                  <p
                                    className="Curriculum-container-file"
                                    key={e.id}
                                  >
                                    {e.name}
                                  </p>
                                </div>

                                <button className="btn-Preview">Preview</button>
                              </div>
                            ) : e.type === "video" ? (
                              <div
                                onClick={() =>
                                  gotovideo(
                                    `/formation/${id}/previewvideo/${e.id}`
                                  )
                                }
                                className="curriculum-element"
                              >
                                <div className="complited-container complited-container-hover">
                                  <img
                                    className="complited-image"
                                    src={videoimg}
                                    alt=""
                                  />

                                  <p key={e.id}>
                                    <Link
                                      className="custom-link Curriculum-container-video"
                                      // to={`/formation/${id}/video/${e.id}`}
                                      key={e.id}
                                    >
                                      {e.name}
                                    </Link>
                                  </p>
                                </div>

                                <button className="btn-Preview">Preview</button>
                              </div>
                            ) : (
                              <div
                                onClick={() =>
                                  gotovideo(
                                    `/formation/${id}/Previewtext/${e.id}`
                                  )
                                }
                                className="curriculum-element"
                              >
                                <div className="complited-container complited-container-hover">
                                  <img
                                    className="complited-image"
                                    src={text}
                                    alt=""
                                  />
                                  <Link
                                    className="custom-link Curriculum-container-text"
                                    to={`/formation/${id}/Previewtext/${e.id}`}
                                    key={e.id}
                                  >
                                    {e.name}
                                  </Link>
                                </div>

                                <button className="btn-Preview">Preview</button>
                              </div>
                            )}
                          </div>
                        );
                      } else {
                        return (
                          <div key={index}>
                            {e.type === "file" ? (
                              <div className="curriculum-element-disabeled">
                                <div className="complited-container complited-container-hover">
                                  <img
                                    className="complited-image"
                                    src={file}
                                    alt=""
                                  />
                                  <p
                                    className="Curriculum-container-file"
                                    // onClick={() => getfile(e)}
                                    key={e.id}
                                  >
                                    {e.name}
                                  </p>
                                </div>

                                <div className="enrolprev-container">
                                  <button
                                    className=" enrollbutton-disabeled"
                                    onClick={handelEnroll}
                                  >
                                    Enroll
                                  </button>
                                  <button className="btn-Preview btn-Preview-disabeled">
                                    Preview
                                  </button>
                                </div>
                              </div>
                            ) : e.type === "video" ? (
                              <div className="curriculum-element-disabeled">
                                <div className="complited-container complited-container-hover">
                                  <img
                                    className="complited-image"
                                    src={videoimg}
                                    alt=""
                                  />

                                  <p
                                    key={e.id}
                                    className="Curriculum-container-video"
                                    // to={`/formation/${id}/video/${e.id}`}
                                  >
                                    {e.name}
                                  </p>
                                </div>

                                <div className="enrolprev-container">
                                  <button
                                    className=" enrollbutton-disabeled"
                                    onClick={handelEnroll}
                                  >
                                    Enroll
                                  </button>
                                  <button className="btn-Preview btn-Preview-disabeled">
                                    Preview
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <div className="curriculum-element-disabeled">
                                <div className="complited-container complited-container-hover">
                                  <img
                                    className="complited-image"
                                    src={text}
                                    alt=""
                                  />
                                  <p
                                    className=" Curriculum-container-text"
                                    // to={`/formation/${id}/text/${e.id}`}
                                    key={e.id}
                                  >
                                    {e.name}
                                  </p>
                                </div>

                                <div className="enrolprev-container">
                                  <button
                                    className=" enrollbutton-disabeled"
                                    onClick={handelEnroll}
                                  >
                                    Enroll
                                  </button>
                                  <button className="btn-Preview btn-Preview-disabeled">
                                    Preview
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      }
                    })}
                  </div>
                );
              }
            }
          })}
      </div>
    </div>
  );
};

export default Presentationformation;
